import { IGenericAsset } from "models/assets.models";
import { DocumentSubtype } from "utils/constants/doc.constants";
import { Path } from "utils/constants/paths.constants";

const getDocumentPath = (
  projectId: string | undefined,
  document:
    | (Pick<IGenericAsset, "id" | "type"> &
        Partial<Pick<IGenericAsset, "source" | "parent">>)
    | undefined,
) => {
  if (document?.type === DocumentSubtype.StructuredDocument) {
    return Path.ProjectStructuredDocument.replace(
      ":projectId",
      projectId ?? "",
    ).replace(":structuredDocumentId", document?.id ?? "");
  }

  if (document?.type === DocumentSubtype.ECTD) {
    return Path.ProjectECTD.replace(":projectId", projectId ?? "").replace(
      ":ECTDId",
      document?.id ?? "",
    );
  }

  if (document?.parent && document?.parent?.type === DocumentSubtype.ECTD) {
    return `${Path.ProjectECTD.replace(":projectId", projectId ?? "").replace(
      ":ECTDId",
      document?.parent?.id ?? "",
    )}${document?.source?.arn ? `?documentId=${document?.source?.arn}` : ""}`;
  }

  return document
    ? Path.ProjectDocument.replace(":projectId", projectId ?? "").replace(
        ":documentId",
        document.id,
      )
    : Path.ProjectDocuments.replace(":projectId", projectId ?? "");
};

export default getDocumentPath;
